import React, { memo, useCallback, useEffect, useState } from 'react';

import CtaCardSchedule from './CtaCardSchedule';
import CtaCardV1 from './CtaCardV1';
import CtaCardV2 from './CtaCardV2';
import CtaCardV3 from './CtaCardV3';
import CtaCardV4 from './CtaCardV4';
import CtaCardV5 from './CtaCardV5';

import ArchiveVideoCardV1 from '../arcchiveVideo/archiveVideoCardV1/ArchiveVideoCardV1';
import MedwikiCardV1 from '../medwiki/medwikiCardV1/MedwikiCardV1';
import QuizCardV1 from '../quiz/quizCardV1/QuizCardV1';
import SessionCardV1 from '../session/sessionCardV1/SessionCardV1';
import SurveyCardV1 from '../survey/surveyCardV1/SurveyCardV1';

import { postAutomatedCtaUserAnalytics } from '../../../Store/actions/automatedCta.action';
import { postAnalyticsCTA } from '../../../Store/actions/commonActions';
import { onCtaCardClick } from '../../../TrackerFolder/actions/UserActions';
import { CLICK_CTA_CARD } from '../../../TrackerFolder/constants/ActionType';
import {
  getLocalStorage,
  isApp,
  isEligibleForSpeciality,
  openNewTab,
  sendPageViewToGa
} from '../../../common/common';
import useRedirect from '../../customHooks/useRedirect';
import ClinicalVideoCardV1 from '../clinicalVideo/ClinicalVideoCardV1';
import GrCardV1 from '../grandRound/grCardV1/GrCardV1';

import { useTracker } from '../../../TrackerFolder/TrackerComponent';

import { toast } from 'react-toastify';
import AnalyticMetrix from '../../../pages/doctube/doctubeProfileManagement/components/dashboard/AnalyticMetrix';
import DynamicCTATemplateCard from '../../baseUiV3/moduleCTA/DynamicCTATemplateCard';
import EventCta from '../../baseUiV3/moduleCTA/EventCta';
import FeaturedServiceCTA from '../../baseUiV3/moduleCTA/FeaturedServiceCTA';
import FeaturedTopCTA from '../../baseUiV3/moduleCTA/FeaturedTopCTA';
import SupportCta from '../../baseUiV3/moduleCTA/SupportCta';
import PollCardV1 from '../poll/pollCardV1/PollCardV1d';
import CTASpeciality from './CTASpeciality';
import CtaCardV12 from './CtaCardV12';
import CtaCardV14 from './CtaCardV14';
import CtaSubscribeDoctorV1 from './CtaSubscribeDoctorV1';
import CtaSubscribeServiceV1 from './CtaSubscribeServiceV1';
import CmeCardV2 from './internal/cme/CmeCardV2';
import { useDispatch } from 'react-redux';
import DoctorsVoiceCard from '../../baseUiV3/cards/DoctorsVoiceCard';
import LeaderboardCta from '../../baseUiV3/moduleCTA/LeaderboardCta';
import LiveWorldCupScoreCTA from './LiveWorldCupScoreCTA';
import Worldcup2023PollCard from '../../baseUiV3/cards/event/Worldcup2023PollCard';
let subscribe_api_call_permission = true;
const masonryPositions = ['before_content', 'after_content'];
function ShowCard({
  data = {},
  index = -1,
  page_name = '',
  page_id = 0,
  position: ctaPosition = ''
}) {
  const dispatch = useDispatch();
  const { trackActivityEvent } = useTracker();
  const { redirectTo } = useRedirect();
  const [isSubscribedDoc, setisSubscribedDoc] = useState(false);
  const [isSubscribedServ, setIsSubscribedServ] = useState(false);
  const [isSubscribedSession, setisSubscribedSession] = useState(false);
  const [rendering, setRendering] = useState(false);

  const {
    id,
    details,
    cta_type,
    button_action,
    cta_url,
    template_id,
    cta_type_id,
    type,
    type_id,
    position,
    entity_id
  } = data;

  useEffect(() => {
    return () => {
      subscribe_api_call_permission = true;
    };
  }, []);
  // report google analytics effect start
  useEffect(() => {
    if (cta_type && details?.length > 0) {
      const host_url = window.location.origin; // returns the absolute URL of a page
      const path_name = window.location.pathname; //returns the current url minus the domain name
      let pageLocation = '';

      switch (cta_type) {
        case 'session':
          pageLocation = `${host_url}${path_name}#/SessionDetails?id=${details[0]?.session_id}&title=${details[0]?.session_topic}`;
          sendPageViewToGa(pageLocation, details[0]?.session_topic, pageLocation);
        case 'comp':
          pageLocation = `${host_url}${path_name}#/MedwikiDetails?id=${details.type_id}&title=${details.question}`;
          sendPageViewToGa(pageLocation, details?.question, pageLocation);
        case 'gr':
          pageLocation = `${host_url}${path_name}#/GrandRoundDetails?id=${details[0].type_id}&title=${details[0].title}`;
          sendPageViewToGa(pageLocation, details[0]?.title, pageLocation);
        case 'survey':
          pageLocation = `${host_url}${path_name}#/SPQdetails?id=${details[0].survey_id}&title=${details[0].survey_title}`;
          sendPageViewToGa(pageLocation, details[0]?.survey_title, pageLocation);

        case 'clinical_video':
          pageLocation = `${host_url}${path_name}#/ClinicalVideoDetails?id=${details.type_id}&title=${details.question}`;
          sendPageViewToGa(pageLocation, details.question, pageLocation);

        default:
          return;
      }
    }
  }, [cta_type, details]);
  // report google analytics effect end
  const onInternalButtonClick = (
    page_name = '',
    page_id = 0,
    page_topic = '',
    button_action = '',
    cta_type = '',
    cta_type_id = 0,
    position = '',
    id = 0
  ) => {
    let postObj = {
      cta_type,
      cta_type_id,
      target_type: page_name,
      target_type_id: page_id,
      position,
      cta_id: id
    };
    if (button_action.toLowerCase() == 'same_Page') {
      dispatch(postAnalyticsCTA(postObj, () => {}));
      trackActivityEvent(CLICK_CTA_CARD, onCtaCardClick(cta_type, cta_type_id, page_id, page_name));
      if (page_id != 0) {
        redirectTo(page_name, page_id, page_topic);
      }
    } else {
      dispatch(postAnalyticsCTA(postObj, () => {}));
      trackActivityEvent(CLICK_CTA_CARD, onCtaCardClick(cta_type, cta_type_id, page_id, page_name));
      const host_url = window.location.origin; // returns the absolute URL of a page
      const path_name = window.location.pathname; //returns the current url minus the domain name
      const targetUrl = `${host_url}${path_name}#/${page_name}?id=${page_id}&title=${page_topic}`;
      //console.log(targetUrl);
      if (isApp()) {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              type: 'OPEN_INTERNAL_CTA',
              payload: targetUrl
            })
          );
        } else {
          alert('This operation is not permitted');
        }
      } else {
        //console.log(targetUrl);
        if (page_id != 0 && page_name != 'poll') {
          openNewTab(targetUrl, () => {
            redirectTo(page_name, page_id, page_topic);
          });
        }
      }
    }
  };

  const onExternalButtonClick = (
    button_action,
    cta_url,
    cta_type,
    cta_type_id,
    type,
    type_id,
    position,
    id
  ) => {
    let postObj = {
      cta_type,
      cta_type_id,
      target_type: type,
      target_type_id: type_id,
      position,
      cta_id: id
    };
    if (button_action.toLowerCase() == 'same_Page') {
      dispatch(postAnalyticsCTA(postObj, () => {}));
      trackActivityEvent(CLICK_CTA_CARD, onCtaCardClick(cta_type, cta_type_id, type, type_id));
      window.location.href = cta_url;
    } else {
      dispatch(postAnalyticsCTA(postObj, () => {}));
      trackActivityEvent(CLICK_CTA_CARD, onCtaCardClick(cta_type, cta_type_id, type, type_id));
      openNewTab(cta_url, () => {
        window.location.href = cta_url;
      });
    }
  };

  const rerender = () => {
    setRendering(!rendering);
  };
  const onSubscribe = useCallback(
    (cta_id, cta_type_id, entity_id, entity_value, action, view_page_type, view_page_id) => {
      if (subscribe_api_call_permission) {
        subscribe_api_call_permission = false;
        dispatch(
          postAutomatedCtaUserAnalytics(
            cta_id,
            cta_type_id,
            entity_id,
            entity_value,
            action,
            view_page_type,
            view_page_id,
            (res) => {
              subscribe_api_call_permission = true;
              if (cta_type_id == 2) {
                toast.success(
                  'Thank you for your subscription. You will now get latest similar sessions '
                );
                setisSubscribedSession(true);
              } else {
                if (entity_id == 2) {
                  toast.success(
                    'Thank you for your subscription. You will now get the latest contents of the speaker'
                  );
                  setisSubscribedDoc(true);
                } else if (entity_id == 3) {
                  toast.success(
                    'Thank you for your subscription. You will now get the latest contents from us'
                  );
                  setIsSubscribedServ(true);
                }
              }
            }
          )
        );
      }
    },
    []
  );

  const reportCtaClick = (ctaId) => {
    console.log('user has clicked a cta', data);
    let postObj = {
      cta_type,
      cta_type_id,
      target_type: page_name,
      target_type_id: page_id,
      position,
      cta_id: id
    };
    dispatch(postAnalyticsCTA(postObj, () => {}));
  };

  const masonryClassByPosition = masonryPositions.includes(position)
    ? 'col-md-6 col-12 mt-4 ps-4 mt-md-5 ps-md-5 pe-0'
    : '';
  const masonaryArr = !!masonryClassByPosition ? masonryClassByPosition.split(' ') : [];

  switch (cta_type) {
    case 'session':
      switch (template_id) {
        case '1':
          return details ? (
            <SessionCardV1
              startSessionCountDown={true}
              data={details[0]}
              click={() => {
                onInternalButtonClick(
                  'SessionDetails',
                  details[0]?.session_id ?? 0,
                  details[0]?.session_topic ?? '',
                  button_action,
                  cta_type,
                  cta_type_id,
                  position,
                  id
                );
              }}
            />
          ) : null;

        case '2':
          return details && details?.length > 0 && !details[0]?.is_booked ? (
            <CmeCardV2
              data={details[0]}
              masonaryArr={masonaryArr}
              // positionClass={positionClass}
              click={() => {
                if (details[0] && details[0]?.session_id) {
                  onInternalButtonClick(
                    'SessionDetails',
                    details[0]?.session_id,
                    details[0]?.session_topic,
                    button_action,
                    cta_type,
                    cta_type_id,
                    position,
                    id
                  );
                }
              }}
            />
          ) : null;

        default:
          return <></>;
      }
    case 'comp':
      return (
        details && (
          <>
            {details.con_type == 'text' && template_id == 1 && (
              <MedwikiCardV1
                medwikiListDetails={details}
                click={() => {
                  onInternalButtonClick(
                    'MedwikiDetails',
                    details.type_id,
                    details.question,
                    button_action,
                    cta_type,
                    cta_type_id,
                    position,
                    id
                  );
                }}
              />
            )}
            {details.con_type == 'video' && template_id == 1 && (
              <ArchiveVideoCardV1
                medWikiListVideoCardDetails={details}
                click={() => {
                  onInternalButtonClick(
                    'MedwikiDetails',
                    details.type_id,
                    details.question,
                    button_action,
                    cta_type,
                    cta_type_id,
                    position,
                    id
                  );
                }}
              />
            )}
          </>
          //   </div>
          // </div>
        )
      );
    case 'gr':
      return (
        <>
          {template_id == 1 && (
            <GrCardV1
              cardData={details[0]}
              click={() => {
                onInternalButtonClick(
                  'GrandRoundDetails',
                  details[0]?.type_id,
                  details[0]?.title,
                  button_action,
                  cta_type,
                  cta_type_id,
                  position,
                  id
                );
              }}
            />
          )}
        </>
      );
    case 'survey':
      return (
        <>
          {details[0] && details[0]?.category == 'survey' && template_id == 1 && (
            <SurveyCardV1
              data={details[0]}
              click={() => {
                onInternalButtonClick(
                  'SPQdetails',
                  details[0]?.survey_id,
                  details[0]?.survey_title,
                  button_action,
                  cta_type,
                  cta_type_id,
                  position,
                  id
                );
              }}
            />
          )}
          {details[0] && details[0]?.category == 'quiz' && template_id == 1 && (
            <QuizCardV1
              data={details[0]}
              click={() => {
                onInternalButtonClick(
                  'SPQdetails',
                  details[0]?.survey_id,
                  details[0]?.survey_title,
                  button_action,
                  cta_type,
                  cta_type_id,
                  position,
                  id
                );
              }}
            />
          )}
          {details[0] && details[0]?.category == 'poll' && template_id == 1 && (
            <PollCardV1
              data={details[0]}
              type="cta"
              click={() => {
                onInternalButtonClick(
                  'poll',
                  details[0]?.survey_id,
                  details[0]?.survey_title,
                  button_action,
                  cta_type,
                  cta_type_id,
                  position,
                  id
                );
              }}
            />
          )}
          {details[0] && details[0]?.category == 'poll' && template_id == 2 && (
            <DoctorsVoiceCard
              className="clr_v3_card__doctorVoice--color"
              type={'doctorVoice'}
              onClickPoll={() => {
                reportCtaClick(id);
              }}
              data={{ ...details[0], json_data: details[0]?.data_json }}
            />
          )}
          {details[0] && details[0]?.category == 'poll' && template_id == 3 && (
            <Worldcup2023PollCard
              page_id={page_id}
              onClickPoll={() => {
                reportCtaClick(id);
              }}
              data={{ ...details[0], json_data: details[0]?.data_json || details[0]?.json_data }}
            />
          )}
        </>
      );
    case 'clinical_video':
      return (
        <>
          {template_id == 1 && (
            <ClinicalVideoCardV1
              data={details}
              click={() => {
                onInternalButtonClick(
                  'ClinicalVideoDetails',
                  details.type_id,
                  details.question,
                  button_action,
                  cta_type,
                  cta_type_id,
                  position,
                  id
                );
              }}
            />
          )}
        </>
      );
    case 'doctube':
      // <div className={masonryClassByPosition} key={index + 1}>
      //   <div className={classByPosition}>
      <AnalyticMetrix
        data={{
          total_channel: '2K+',
          total_videos: '11898',
          total_users: '3621'
        }}
      />;

    case 'ddx':
      // <div className={masonryClassByPosition} key={index + 1}>
      //   <div className={classByPosition}>
      <FeaturedServiceCTA ctaId={id} clickCallback={reportCtaClick} />;

    case 'external':
      switch (template_id) {
        case '1':
          return (
            data && (
              <CtaCardV1
                data={data}
                callback={() =>
                  onExternalButtonClick(
                    button_action,
                    cta_url,
                    cta_type,
                    cta_type_id,
                    type,
                    type_id,
                    position,
                    id
                  )
                }
              />
            )
          );

        case '2':
          return (
            data && (
              <CtaCardV2
                data={data}
                callback={() =>
                  onExternalButtonClick(
                    button_action,
                    cta_url,
                    cta_type,
                    cta_type_id,
                    type,
                    type_id,
                    position,
                    id
                  )
                }
              />
            )
          );
        case '3':
          return (
            data && (
              <CtaCardV3
                data={data}
                callback={() =>
                  onExternalButtonClick(
                    button_action,
                    cta_url,
                    cta_type,
                    cta_type_id,
                    type,
                    type_id,
                    position,
                    id
                  )
                }
              />
            )
          );
        case '4':
          return (
            data && (
              <CtaCardV4
                data={data}
                callback={() =>
                  onExternalButtonClick(
                    button_action,
                    cta_url,
                    cta_type,
                    cta_type_id,
                    type,
                    type_id,
                    position,
                    id
                  )
                }
              />
            )
          );
        case '5':
          return (
            data && (
              <CtaCardV5
                data={data}
                callback={() =>
                  onExternalButtonClick(
                    button_action,
                    cta_url,
                    cta_type,
                    cta_type_id,
                    type,
                    type_id,
                    position,
                    id
                  )
                }
              />
            )
          );

        case '6':
          return (
            <DynamicCTATemplateCard
              clickCallback={reportCtaClick}
              buttonIcon={data?.settings?.buttonIcon}
              form={data?.form ?? []}
              buttonAction={button_action}
              ctaUrl={cta_url}
              ctaId={data?.id}
              ctaType={data?.cta_type}
              key={'dynamic_cta_external' + index}
              title={data?.title}
              buttonText={data?.button_text}
              logo={data?.logo}
              description={data?.description}
              {...data?.settings}
            />
          );
        case '7':
        case '8':
          return (
            <SupportCta
              clickCallback={reportCtaClick}
              ctaId={data?.id}
              ctaType={data?.cta_type}
              onClick={() => {}}
              buttonText={data?.button_text}
              description={data?.description}
              form={data?.form}
              title={data?.title}
              isForm={template_id == '7'}
              key={'cta_support'}
              buttonAction={button_action}
            />
          );

        default:
          return <></>;
      }

    case 'schedule':
      switch (template_id) {
        case '1':
          return (
            data && (
              <div
                key={index + 1}
                // className={
                //   position != 'after_related' && position != 'before_related'
                //     ? 'col-12 mt-4 ps-4 mt-md-5 ps-md-5 pe-0'
                //     : ''
                // }
              >
                <CtaCardSchedule
                  content_type={page_name}
                  content_id={page_id}
                  data={data}
                  onVisibilityChange={rerender}
                />
              </div>
            )
          );

        default:
          return <></>;
      }

    case 'subscribe':
      switch (entity_id) {
        case '1':
          return data ? (
            <CTASpeciality
              position={position}
              data={{ ...data, speciality_id: data?.entity_value }}
            />
          ) : null;
        case '2':
          return data ? (
            <CtaSubscribeDoctorV1
              data={{ ...data, doctor_id: data?.entity_value }}
              onClickCallback={onSubscribe}
              isSubscribed={isSubscribedDoc}
            />
          ) : null;
        case '3':
          return data ? (
            <CtaSubscribeServiceV1
              data={{ ...data, service: data?.entity_value }}
              onClickCallback={onSubscribe}
              isSubscribed={isSubscribedServ}
            />
          ) : null;
        default:
          return <></>;
      }
    case 'certificate':
      return <CtaCardV14 data={data} onClickCallback={onSubscribe} />;
    case 'session_reserve':
      return (
        <CtaCardV12 data={data} onClickCallback={onSubscribe} isSubscribed={isSubscribedSession} />
      );

    case 'featured_content':
      return position == 'top' ? (
        <FeaturedTopCTA
          clickCallback={reportCtaClick}
          buttonAction={button_action}
          ctaId={id}
          ctaType={cta_type}
          ctaUrl={cta_url}
          form={data?.form ?? []}
          labelObj={data?.settings?.labelObj ?? {}}
          key={'featured' + index}
          title={data?.title}
          buttonText={data?.button_text}
          logo={data?.logo}
          description={data?.description}
          image={data?.image}
          {...data?.settings}
        />
      ) : (
        <DynamicCTATemplateCard
          clickCallback={reportCtaClick}
          buttonIcon={data?.settings?.buttonIcon}
          form={data?.form ?? []}
          buttonAction={button_action}
          ctaUrl={cta_url}
          ctaId={data?.id}
          ctaType={data?.cta_type}
          key={'dynamic_cta_top' + index}
          title={data?.title}
          buttonText={data?.button_text}
          logo={data?.logo}
          description={data?.description}
          {...data?.settings}
        />
      );
    case 'leaderboard':
      return (
        <LeaderboardCta
          id={cta_type_id}
          ctaType={data?.cta_type}
          ctaId={data?.id}
          logo={data?.logo}
          page_name={page_name}
          page_id={page_id}
        />
      );
    case 'event':
      return (
        <EventCta
          ctaId={id}
          clickCallback={reportCtaClick}
          ctaType={cta_type}
          form={data?.form ?? []}
          onClick={() => {}}
          description={data?.description}
          image={data?.image}
          title={data?.title}
          subTitle={data?.sub_header}
          logo={data?.logo}
          {...data?.settings}
        />
      );

    case 'iframe':
      return (
        <div className="w-100">
          <LiveWorldCupScoreCTA logo={data?.logo} id={data?.id} page_id={page_id} />
        </div>
      );

    default:
      return <></>;
  }
}

function ShowCardByType({
  data = {},
  index = -1,
  page_name = '',
  page_id = 0,
  position: ctaPosition = ''
}) {
  return (
    <Wrapper position={data?.position} cta_type={data?.cta_type}>
      <ShowCard
        data={data}
        index={index}
        page_id={page_id}
        page_name={page_name}
        position={ctaPosition}
      />
    </Wrapper>
  );
}

export default memo(ShowCardByType);

function Wrapper({ position, cta_type, children }) {
  const isSpecialityEligible = isEligibleForSpeciality(getLocalStorage('user', '{}'));
  if (masonryPositions?.includes(position) && cta_type != 'schedule') {
    return <div className="col-md-6 col-12 mt-4 ps-4 mt-md-5 ps-md-5 pe-0">{children}</div>;
  } else {
    return isSpecialityEligible ? children : <div className="mb-3">{children}</div>;
  }
}
